import React from "react";
import bgImage from "../media3/homebg.webp"; 
import Header from "../component/Header.jsx";
import building from "../media3/building.svg";
import homeicon1 from "../media3/homeicon1.svg";
import homeicon2 from "../media3/homeicon2.svg";
function HomePage({ isLoggedIn, setLoginModalOpen, handleLogout }) {

    const handleExploreClick = () => {
    const upcomingSkinsSection = document.getElementById('upcoming-skins');
    if (upcomingSkinsSection) {
      upcomingSkinsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="homepage"  id="homepage-section">
      <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <section className="hero">
        <div className="hero-title">
          <h1>Forge Your Arsenal. Dominate Every Match.</h1>
       
        <p className="hero-subtitle">
          {/* Track skins, spot rising trends, and discover what's in demand all in one live marketplace built for gamers, traders, and collectors. */}
          The ultimate hub for skin enthusiasts and pro traders alike. Discover trends, explore values, and grow your collection effortlessly.
        </p>
          <button className="explore-btn" onClick={handleExploreClick}>Explore More</button>
         </div>
      </section>

      <section className="homepage-footer">
        <div className="homepage-footer-content">
         <div className="footer-item">
        <img src={homeicon1} alt="Quiz" className="footer-svg" />
        <div className="footer-text">
        <h3>Find Your Perfect Skin</h3>
        <p>Explore trending designs, rare drops, and exclusive skins built for you.</p>
      </div>
    </div>

           <div className="footer-item">
      <img src={homeicon2} alt="Customized" className="footer-svg" />
        <div className="footer-text">
        <h3>Tailored Skin Picks</h3>
<p>Discover curated skin selections perfectly suited to your favorite weapons.</p>

      </div>
    </div>

              <div className="footer-item">
      <img src={building} alt="Building" className="footer-svg" />
      <div className="footer-text">
       <h3>Master Your Collection</h3>
        <p>Build a legendary inventory with rare skins that define your collection.</p>

      </div>
    </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;